import { Component, useEffect, useRef } from "react";
import { createRef } from "react";
import MovingCircle from "./MovingCircle";
import React from 'react'
class TaskRow extends Component {
    state = {
        isTask: false,
        showRowShadow: false,
        showTaskCircle: false,
    };

    rowRef = createRef();
    changeBackground = (e) => {
        !this.state.isTask && this.props.setHoveredId(this.props.id);
        const element = document.getElementById(this.props.id);
        let circleLeft = element && Number(element.style.left.split("px")[0])
        if (!this.state.isTask && circleLeft >= 0) {
            this.setState({ showRowShadow: true, showTaskCircle: true });
        }
    };

    removeBackground = (e) => {
        console.log('MOUSE LEAVE')
        this.props.setHoveredId(null);
        this.setState({
            showRowShadow: false,
            showTaskCircle: this.state.isTask ? true : false
        });
        // movingRef.current.style.display = 'none'
    };

    setTask = (e, index) => {
        const element = document.getElementById(this.props.id);
        console.log(this.props.id, "id")
        let left = Number(element.style.left.split("px")[0]);
        let dateIndex = Math.round(left / 25);
        let dateWeekIndex = Math.floor(dateIndex / 7);
        let dateArray = this.props.date;
        let foundDayIndex = dateIndex - (dateWeekIndex * 7);
        let foundDay = dateArray[dateWeekIndex].weekDays[foundDayIndex];
        // let foundElement = document.getElementById(foundDay.unix());
        // let eleRect = foundElement.getBoundingClientRect();
        element.style.left = (dateIndex * 25) + "px";
        let taskId = this.props.id
        // this.props.setTaskTimestamp(taskId, this.props.timeline.startDate, this.props.timeline.endDate);
        this.setState({ isTask: true, showTaskCircle: true }, () => {
            this.rowRef.current.removeEventListener(
                "mousemove",
                this.calcMouseMove
            );
            // this.rowRef.current.removeEventListener(
            //     "mousemove",
            //     this.calcMouseMove
            // );
        });
        // this.rowRef.current.classList.remove("shadow-row-bg");
    };
    calcMouseMove = (e) => {
        const element = document.getElementById(this.props.id);
        console.log(this.props.id, "id")
        let bounding = this.props.windowRect
        let listDiv = document.getElementById("list-items-holde");
        let srollLeft = document.getElementById('gantt').scrollLeft
        let listBounding = listDiv.getBoundingClientRect();
        let circleLeft = Number(element.style.left.split("px")[0])
        if (element && circleLeft >= 0) element.style.left = srollLeft + e.clientX - listBounding.right - 12.5 + "px";
        
        // rowRef.current.style.left = 1000;
        // rowRef.current.style.backgroundcolor = 'red'
        // if (e.pageX > 371) setLeft(prev => {
        //     // console.log(prev, 'prev');
        //     // console.log(e.clientX, e.pageX);
        //     return e.pageX - 371;
        // });
    };
    componentDidMount() {
        this.rowRef.current.addEventListener("mousemove", this.calcMouseMove);
        
    }
    componentWillUnmount() {
        this.rowRef.current.removeEventListener(
            "mousemove",
            this.calcMouseMove
            
        );
    }

    render() {
        const { id, index, holderWidth } = this.props
        return (
            <div
                className={
                    "shadow-row " +
                    (this.state.showRowShadow ? "shadow-row-bg" : "")
                }
                ref={this.rowRef}
                style={{
                    width: "inherit",
                    position: "absolute",
                    top: 74 + (index) * 35,
                }}
                onClick={(e) => {
                    !this.state.isTask && this.setTask(e, index)
                }}
                onMouseEnter={(e) => !this.state.isTask && this.changeBackground(e)}
                onMouseLeave={(e) => this.state.showRowShadow && this.removeBackground(e)}

            >

                {this.state.showTaskCircle ? (
                    <MovingCircle
                        holderWidth={holderWidth}
                        id={id}
                        timeline={this.props.timeline}
                        title={this.props.title}
                        isTask={this.state.isTask}
                        showTaskHanles={this.state.isTask}
                        changeTaskTimeStamp={this.props.changeTaskTimeStamp}
                    />
                ) : null}
            </div>
        );
    }
}

export default TaskRow;
